import { render } from "./SurveyCard.vue?vue&type=template&id=08414ffa"
import script from "./SurveyCard.vue?vue&type=script&lang=js"
export * from "./SurveyCard.vue?vue&type=script&lang=js"

import "./SurveyCard.vue?vue&type=style&index=0&id=08414ffa&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__